import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { Tooltip, QuestionMarkOutlined } from '@netbasequid/core'
import { TileProps, variationhandler } from 'components/visualization/Tile'
import { useDisplayTheme, useSysTheme } from 'hooks/useUiState'
import { Theme } from 'features/ui/types'
import { SystemTheme } from 'hooks/useUiState/types'

const Container = styled.div``

const Title = styled.div<{ $theme: SystemTheme }>`
  font-weight: ${({ $theme }) => $theme.fontWeight.semibold};
  font-size: ${({ $theme }) => $theme.typescale[14].size};
  line-height: ${({ $theme }) => $theme.typescale[14].lineHeight};
  display: flex;
  align-items: center;
  gap: 4px;
`

const Content = styled.div`
  display: flex;
  gap: 8px;
`

const Value = styled.div<{ $theme: SystemTheme }>`
  font-weight: ${({ $theme }) => $theme.fontWeight.regular};
  font-size: ${({ $theme }) => $theme.typescale[32].size};
  line-height: ${({ $theme }) => $theme.typescale[32].lineHeight};
`

const Diff = styled.div`
  display: flex;
  align-items: center;
`

const Tile = ({ title, value, variation, infoTooltipContent }: TileProps) => {
  const mode = useDisplayTheme() as Theme
  const theme = useSysTheme()

  return (
    <Container>
      <Title $theme={theme}>
        {title}
        <Tooltip mode={mode} content={infoTooltipContent}>
          <QuestionMarkOutlined color={theme.text.placeholder} />
        </Tooltip>
      </Title>
      <Content>
        <Value $theme={theme}>{value}</Value>
        <Diff>{variation && variationhandler(variation, mode)}</Diff>
      </Content>
    </Container>
  )
}

export default Tile
